import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  withRouter
} from 'react-router-dom';
import PageHelmet from '../../organisms/PageHelmet';
import Polls from '../../organisms/Polls';
import AgendaDay from '../../organisms/AgendaDay';
import AgendaNav from './AgendaNav';
import LoadingIndicator from '../../atoms/LoadingIndicator';
import {
  today,
  AgendaDateAsDay
} from '../../../module/Dates';
import {
  resolveParams
} from '../../../module/RoutingUtils';

class Agenda extends Component {

  constructor(...args) {
    super(...args);
    this.state = {
      dates: []
    };
  }

  componentWillMount() {
    this.setState({
      dates: this.agendaDates(this.props.agenda)
    }, () => {
      this.redirectToDate(this.props.match.params);
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dates: this.agendaDates(nextProps.agenda)
    }, () => {
      this.redirectToDate(nextProps.match.params);
    });
  }

  redirectToDate = (params) => {
    const {dates} = this.state;
    let dateToday = today(), i, goToDate = dates[0];
    if ( !(params && params.date) ) {
      // if today is in the list of dates, then show that by default
      // otherwise just show the first item in the list
      for ( i=0; i<dates.length; i+=1 ) {
        if ( dates[i] === dateToday ) {
          goToDate = dates[i];
          break;
        }
      }
      if ( goToDate ) {
        this.props.history.push(resolveParams({
          path: this.props.match.path.replace(":date?", goToDate),
          params: this.props.match.params,
        }));
      }
    }
  }

  agendaDates = (agenda) => {
    return Object.keys(agenda).map(id => {
      return agenda[id].date;
    }).sort();
  }

  agendaByDate = (date) => {
    const {agenda} = this.props;
    let prop;
    for ( prop in agenda ) {
      if ( agenda[prop].date === date ) {
        return agenda[prop];
      }
    }
    return null;
  }

  render() {
    const {match, loading} = this.props;
    const {dates} = this.state;

    // find the in-view agenda day
    let inViewDate;
    if ( match.params && match.params.date ) {
      inViewDate = this.agendaByDate(match.params.date);
    }

    if ( loading && !inViewDate && !(dates.length > 0) ) {
      return (
        <div>
          <LoadingIndicator />
        </div>
      );
    }

    return (
      <div className="Agenda">

        <PageHelmet pageTitle={inViewDate ? AgendaDateAsDay(inViewDate.date) : "Agenda"} />

        {dates.length > 0 ? (
          <div>
            <AgendaNav dates={dates} />

            {inViewDate && (
              <AgendaDay {...inViewDate} />
            )}
          </div>
        ) : (
          <Polls />
        )}

      </div>
    );
  }

}

Agenda.propTypes = {
  agenda: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withRouter(Agenda);



// WEBPACK FOOTER //
// ./src/component/pages/Agenda/component.js